module.exports = __webpack_public_path__ + "assets/img/close_all_child_item.51af03d0.png";